exports = module.exports = require("./../../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".weui-cells{margin-top:0}.weui-cells:after,.weui-cells:before{display:none}.weui-cells p{margin-bottom:0}", "", {"version":3,"sources":["/./src/components/panel/panel.vue"],"names":[],"mappings":"AACA,YAAY,YAAY,CACvB,AACD,qCAAqC,YAAY,CAChD,AACD,cAAc,eAAe,CAC5B","file":"panel.vue","sourcesContent":["\n.weui-cells{margin-top:0\n}\n.weui-cells:before,.weui-cells:after{display:none\n}\n.weui-cells p{margin-bottom:0\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-6aac02d8!./~/.2.2.3@less-loader?sourceMap!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/components/panel/panel.vue
// module id = 93
// module chunks = 0